import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
  Card,
  Statistic,
  Typography,
  Button,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  SwitchItem,
} from "../../../../Components/Items";
import {
  FileExcelOutlined,
  FilePdfOutlined,
  ShoppingCartOutlined,
  SwapOutlined,
  ToolOutlined,
  WarningOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
import reporteCostoTotalProyectoPdf from "../../../../Pdf/reporteCostoTotalProyectoPdf";

moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;
const { Text } = Typography;

class ReporteCostoInventario extends Component {
  state = {
    loading: false,
    dataReporte: null,
    resumen: null,
    detalleCompras: [],
    detalleTraspasos: [],
    detalleProduccion: [],
    detalleBajas: [],
    costoTotalProyecto: 0,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                      value.nivel2 +
                      value.nivel3 +
                      value.nivel4 +
                      value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.consultarReporteCostoProyecto();
  }

  consultarReporteCostoProyecto(values) {
    this.setState({ loading: true });

    axios
      .post(
        "reportesDeInventario/reporteCostoProyecto",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const {
            resumen,
            detalleCompras,
            detalleTraspasos,
            detalleProduccion,
            detalleBajas,
          } = res.data;

          const costoTotalProyecto =
            (resumen?.compras?.reduce((a, b) => a + b.totalCompras, 0) || 0) +
            (resumen?.traspasos?.reduce((a, b) => a + b.totalTraspasos, 0) ||
              resumen?.salidas?.reduce((a, b) => a + b.totalSalidas, 0) ||
              0) +
            (resumen?.produccion || 0) +
            (resumen?.bajas?.reduce((a, b) => a + b.totalBajas, 0) ||
              resumen?.bajasConsignacion?.reduce(
                (a, b) => a + b.totalBajaConsignacion,
                0
              ) ||
              0);

          this.setState({
            loading: false,
            dataReporte: res.data,
            resumen,
            detalleCompras: detalleCompras || [],
            detalleTraspasos: detalleTraspasos || [],
            detalleProduccion: detalleProduccion || [],
            detalleBajas: detalleBajas || [],
            costoTotalProyecto,
          });
        } else {
          message.error("No se pudo generar el reporte");
          this.setState({ loading: false });
        }
      });
  }

  descargarExcelGeneral() {
    const { resumen, detalleCompras, detalleTraspasos, detalleProduccion, detalleBajas } = this.state;

    const totalCompras =
      resumen?.compras?.reduce((a, b) => a + b.totalCompras, 0) || 0;
    const totalTraspasos =
      resumen?.traspasos?.reduce((a, b) => a + b.totalTraspasos, 0) ||
      resumen?.salidas?.reduce((a, b) => a + b.totalSalidas, 0) ||
      0;
    const totalProduccion = resumen?.produccion || 0;
    const totalBajas =
      resumen?.bajas?.reduce((a, b) => a + b.totalBajas, 0) ||
      resumen?.bajasConsignacion?.reduce((a, b) => a + b.totalBajaConsignacion, 0) ||
      0;

    const dataResumen = [
      { Concepto: "Compras", Monto: totalCompras },
      { Concepto: "Traspasos", Monto: totalTraspasos },
      { Concepto: "Producción", Monto: totalProduccion },
      { Concepto: "Bajas de Inventario", Monto: totalBajas },
      { Concepto: "TOTAL PROYECTO", Monto: totalCompras + totalTraspasos + totalProduccion + totalBajas },
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(dataResumen), "Resumen");
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(this.mapDetalleComprasExcel(detalleCompras)), "Compras");
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(this.mapDetalleTraspasoExcel(detalleTraspasos)), "Traspasos");
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(this.mapDetalleProduccionExcel(detalleProduccion)), "Producción");
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(this.mapDetalleBajasExcel(detalleBajas)), "Bajas de Inventario");

    XLSX.writeFile(workbook, `Costo_Total_Proyecto_${moment().locale("es").format("L")}.xlsx`);
  }

  mapDetalleComprasExcel(data) {
    return data.map((r) => ({
      Proyecto: r.proyecto || "",
      Proveedor: r.proveedor || "",
      Folio: r.folio || "",
      Insumo: r.insumo || "",
      Cantidad: Number(r.cantidad),
      "Precio Unitario": Number(r.precioUnitario || r.costo),
      Total: Number(r.total || r.totalCompras),
      Fecha: r.fecha ? moment(r.fecha).format("DD/MM/YYYY") : "",
    }));
  }

  mapDetalleTraspasoExcel(data) {
    return data.map((r) => ({
      Proyecto: r.proyecto || "",
      Insumo: r.insumo || "",
      Cantidad: Number(r.cantidad),
      "Costo Unitario": Number(r.costo || r.costoUnitario),
      "Costo Total": Number(r.total || r.totalSalidas || r.totalTraspasos),
      "Proyecto Destino": r.proyectoDestino || "",
      Fecha: r.fecha ? moment(r.fecha).format("DD/MM/YYYY") : "",
    }));
  }

  mapDetalleProduccionExcel(data) {
    return data.map((r) => ({
      Proyecto: r.proyecto || "",
      "Orden de Producción": r.orden || r.folio || "",
      Producto: r.producto || "",
      Insumo: r.insumo || "",
      Cantidad: Number(r.cantidad),
      "Costo Unitario": Number(r.costo || r.costoUnitario),
      "Costo Total": Number(r.total || r.totalProduccion),
      Fecha: r.fecha ? moment(r.fecha).format("DD/MM/YYYY") : "",
    }));
  }

  mapDetalleBajasExcel(data) {
    return data.map((r) => ({
      Proyecto: r.proyecto || r.descripcionProyectos || "",
      Insumo: r.insumo || "",
      Concepto: r.concepto || "",
      Cantidad: Number(r.cantidad),
      "Costo Unitario": Number(r.costo),
      "Costo Total": Number(r.total),
      Fecha: r.fecha ? moment(r.fecha).format("DD/MM/YYYY") : "",
    }));
  }

  descargarExcelDetalle(tipo) {
    const workbook = XLSX.utils.book_new();
    let datos = [];
    let nombreHoja = "";
    let nombreArchivo = "";

    if (tipo === "compras") {
      datos = this.mapDetalleComprasExcel(this.state.detalleCompras);
      nombreHoja = "Compras";
      nombreArchivo = "Detalle_Compras";
    } else if (tipo === "traspasos") {
      datos = this.mapDetalleTraspasoExcel(this.state.detalleTraspasos);
      nombreHoja = "Traspasos";
      nombreArchivo = "Detalle_Traspasos";
    } else if (tipo === "produccion") {
      datos = this.mapDetalleProduccionExcel(this.state.detalleProduccion);
      nombreHoja = "Producción";
      nombreArchivo = "Detalle_Produccion";
    } else if (tipo === "bajas") {
      datos = this.mapDetalleBajasExcel(this.state.detalleBajas);
      nombreHoja = "Bajas de Inventario";
      nombreArchivo = "Detalle_Bajas";
    }

    if (!datos.length) {
      message.warning("No hay datos para exportar");
      return;
    }

    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(datos), nombreHoja);
    XLSX.writeFile(workbook, `${nombreArchivo}_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarPdf() {
    pdfMake
      .createPdf(reporteCostoTotalProyectoPdf(this.state.dataReporte))
      .download(`Reporte_Costo_Proyecto_${moment().locale("es").format("L")}`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const { resumen, detalleCompras, detalleTraspasos, detalleProduccion, detalleBajas } = this.state;

    const columnsCompras = [
      { title: "Proyecto", dataIndex: "proyecto" },
      { title: "Proveedor", dataIndex: "proveedor" },
      { title: "Folio", dataIndex: "folio" },
      { title: "Insumo", dataIndex: "insumo" },
      { title: "Cantidad", dataIndex: "cantidad", align: "right" },
      {
        title: "Precio Unitario",
        dataIndex: "precioUnitario",
        align: "right",
        render: (v, r) => dineroDisabledMask((v || r.costo) || 0),
      },
      {
        title: "Total",
        dataIndex: "total",
        align: "right",
        render: (v, r) => dineroDisabledMask((v || r.totalCompras) || 0),
      },
      {
        title: "Fecha",
        dataIndex: "fecha",
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : ""),
      },
    ];

    const columnsTraspasos = [
      { title: "Proyecto", dataIndex: "proyecto" },
      { title: "Insumo", dataIndex: "insumo" },
      { title: "Cantidad", dataIndex: "cantidad", align: "right" },
      {
        title: "Costo Unitario",
        dataIndex: "costo",
        align: "right",
        render: (v, r) => dineroDisabledMask((v || r.costoUnitario) || 0),
      },
      {
        title: "Costo Total",
        dataIndex: "total",
        align: "right",
        render: (v, r) => dineroDisabledMask((v || r.totalSalidas || r.totalTraspasos) || 0),
      },
      { title: "Proyecto Destino", dataIndex: "proyectoDestino" },
      {
        title: "Fecha",
        dataIndex: "fecha",
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : ""),
      },
    ];

    const columnsProduccion = [
      { title: "Proyecto", dataIndex: "proyecto" },
      { title: "Orden", dataIndex: "orden", render: (v, r) => v || r.folio },
      { title: "Producto", dataIndex: "producto" },
      { title: "Insumo", dataIndex: "insumo" },
      { title: "Cantidad", dataIndex: "cantidad", align: "right" },
      {
        title: "Costo Unitario",
        dataIndex: "costo",
        align: "right",
        render: (v, r) => dineroDisabledMask((v || r.costoUnitario) || 0),
      },
      {
        title: "Costo Total",
        dataIndex: "total",
        align: "right",
        render: (v, r) => dineroDisabledMask((v || r.totalProduccion) || 0),
      },
      {
        title: "Fecha",
        dataIndex: "fecha",
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : ""),
      },
    ];

    const columnsBajas = [
      { title: "Proyecto", dataIndex: "proyecto" },
      { title: "Insumo", dataIndex: "insumo" },
      { title: "Cantidad", dataIndex: "cantidad", align: "right" },
      {
        title: "Costo Unitario",
        dataIndex: "costo",
        align: "right",
        render: (v) => dineroDisabledMask(v || 0),
      },
      {
        title: "Costo Total",
        dataIndex: "total",
        align: "right",
        render: (v) => dineroDisabledMask(v || 0),
      },
      { title: "Motivo", dataIndex: "concepto" },
      {
        title: "Fecha",
        dataIndex: "fecha",
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : ""),
      },
    ];

    const columnsResumen = [
      {
        title: "Concepto",
        dataIndex: "concepto",
        render: (text) => <Text strong>{text}</Text>,
      },
      {
        title: "Monto",
        dataIndex: "monto",
        align: "right",
        render: (v) => (
          <Text style={{ fontSize: "15px", fontWeight: 500 }}>
            {dineroDisabledMask(v)}
          </Text>
        ),
      },
    ];

    const sumCompras =
      resumen?.compras?.reduce((acc, v) => acc + (v.totalCompras || 0), 0) || 0;

    const sumTraspasos =
      resumen?.traspasos?.reduce((acc, v) => acc + (v.totalTraspasos || 0), 0) ||
      resumen?.salidas?.reduce((acc, v) => acc + (v.totalSalidas || 0), 0) ||
      0;

    const sumProduccion = resumen?.produccion || 0;

    const sumBajas =
      resumen?.bajas?.reduce((acc, v) => acc + (v.totalBajas || 0), 0) ||
      resumen?.bajasConsignacion?.reduce((acc, v) => acc + (v.totalBajaConsignacion || 0), 0) ||
      0;

    const dataResumen = resumen
      ? [
          { concepto: "Compras", monto: sumCompras },
          { concepto: "Traspasos", monto: sumTraspasos },
          { concepto: "Producción", monto: sumProduccion },
          { concepto: "Bajas de Inventario", monto: sumBajas },
        ]
      : [];

    const tablaDetalle = (tipo, columns, data) => (
      <>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
          <Button
            icon={<FileExcelOutlined />}
            onClick={() => this.descargarExcelDetalle(tipo)}
            disabled={!data.length}
          >
            Descargar Excel
          </Button>
        </div>
        <TableItem
          columns={columns}
          dataSource={data}
          pagination={{ pageSize: 20 }}
          size="middle"
          scroll={{ x: true }}
        />
      </>
    );

    return (
      <>
        <Form
          ref={this.formRef}
          name="rerpoteCostoInventario"
          onFinish={this.consultarReporteCostoProyecto.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte de Costo Total de Proyecto"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 20,
              borderRadius: "8px",
            }}
            extra={
              <Space size="middle">
                {this.state.dataReporte && (
                  <>
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcelGeneral()}
                      icon={<FileExcelOutlined />}
                    >
                      Excel General
                    </ButtonItem>
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                    >
                      PDF
                    </ButtonItem>
                  </>
                )}
                <ButtonItem type="primary" htmlType="submit">
                  Consultar
                </ButtonItem>
              </Space>
            }
          />

          {/* Costo Total */}
          <Card
            style={{
              marginBottom: 20,
              borderRadius: "8px",
              backgroundColor: "#1890ff",
              border: "none",
            }}
          >
            <Statistic
              title={
                <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: "16px" }}>
                  Costo Total del Proyecto
                </Text>
              }
              value={this.state.costoTotalProyecto}
              formatter={(value) => (
                <Text style={{ color: "white", fontSize: "36px", fontWeight: "bold" }}>
                  {dineroDisabledMask(value)}
                </Text>
              )}
              prefix={<DollarOutlined style={{ color: "white" }} />}
            />
          </Card>

          <Spin spinning={this.state.loading}>
            {/* Cards de resumen por categoría */}
            {resumen && (
              <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                {[
                  { label: "Compras", value: sumCompras, icon: <ShoppingCartOutlined style={{ color: "white" }} /> },
                  { label: "Traspasos", value: sumTraspasos, icon: <SwapOutlined style={{ color: "white" }} /> },
                  { label: "Producción", value: sumProduccion, icon: <ToolOutlined style={{ color: "white" }} /> },
                  { label: "Bajas de Inventario", value: sumBajas, icon: <WarningOutlined style={{ color: "white" }} /> },
                ].map(({ label, value, icon }) => (
                  <Col xs={24} sm={12} lg={6} key={label}>
                    <Card
                      bordered={false}
                      style={{ borderRadius: "8px", backgroundColor: "#1890ff" }}
                    >
                      <Statistic
                        title={<Text style={{ color: "rgba(255,255,255,0.9)" }}>{label}</Text>}
                        value={value}
                        formatter={(v) => (
                          <Text style={{ color: "white", fontSize: "24px", fontWeight: 600 }}>
                            {dineroDisabledMask(v)}
                          </Text>
                        )}
                        prefix={icon}
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            )}

            {/* Tabs */}
            <Card style={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
              <Tabs type="card" style={{ margin: 0 }}>
                <TabPane
                  tab={<span><ShoppingCartOutlined /> Filtros</span>}
                  key="filtros"
                >
                  <Card
                    type="inner"
                    title={<Text strong>Configuración de Proyecto</Text>}
                    style={{ marginBottom: 16 }}
                  >
                    <Row gutter={16}>
                      <Col xs={24} md={12}>
                        <FormItem
                          label="Tipo de Filtro"
                          name="filtrarProyecto"
                          required
                          initialValue={0}
                        >
                          <SelectItem placeholder="Seleccione tipo de filtro">
                            <Option value={0}>Ninguno</Option>
                            <Option value={1}>Proyectos</Option>
                            <Option value={2}>Unidades de Negocio</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col xs={24} md={12}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const filtrarProyecto = getFieldValue("filtrarProyecto");
                            if (filtrarProyecto === 1) {
                              return (
                                <FormItem required name="proyectos" label="Proyectos">
                                  <SelectItem placeholder="Seleccione proyectos" mode="multiple">
                                    {this.state.objetoProyectos}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                            if (filtrarProyecto === 2) {
                              return (
                                <FormItem required name="unidadDeNegocioId" label="Unidad de Negocio">
                                  <SelectItem placeholder="Seleccione unidad">
                                    {this.state.objetoUniadesDeNegocio}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                  </Card>
                  <Card type="inner" title={<Text strong>Opciones de Visualización</Text>}>
                    <FormItem
                      label="Separar por Proyectos"
                      name="separarProyectos"
                      valuePropName="checked"
                    >
                      <SwitchItem />
                    </FormItem>
                  </Card>
                </TabPane>

                <TabPane
                  tab={<span><DollarOutlined /> Resumen</span>}
                  key="resumen"
                >
                  <TableItem
                    columns={columnsResumen}
                    dataSource={dataResumen}
                    pagination={false}
                    size="middle"
                  />
                </TabPane>

                <TabPane
                  tab={<span><ShoppingCartOutlined /> Compras ({detalleCompras.length})</span>}
                  key="compras"
                >
                  {tablaDetalle("compras", columnsCompras, detalleCompras)}
                </TabPane>

                <TabPane
                  tab={<span><SwapOutlined /> Traspasos ({detalleTraspasos.length})</span>}
                  key="traspasos"
                >
                  {tablaDetalle("traspasos", columnsTraspasos, detalleTraspasos)}
                </TabPane>

                <TabPane
                  tab={<span><ToolOutlined /> Producción ({detalleProduccion.length})</span>}
                  key="produccion"
                >
                  {tablaDetalle("produccion", columnsProduccion, detalleProduccion)}
                </TabPane>

                <TabPane
                  tab={<span><WarningOutlined /> Bajas de Inventario ({detalleBajas.length})</span>}
                  key="bajas"
                >
                  {tablaDetalle("bajas", columnsBajas, detalleBajas)}
                </TabPane>
              </Tabs>
            </Card>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteCostoInventario);
